// Route table + sidebar nav, mirroring src/user/routes/index.jsx (AppRouter + pagesListing).
// Vite needs literal import() specifiers for code-splitting, so every loader is a literal arrow.

// Sidebar entries in the React `pagesListing` order, with the same labels. React ran 7 of these
// through t() and hard-coded the other 3 as English literals ("Deposit Addresses", "Payment Link",
// "Payouts"), which meant they never translated; all 10 now use a nav_* key that exists in both
// languages.
export const NAV = [
  { key: "nav_balances", route: "/balances" },
  { key: "nav_client", route: "/client" },
  { key: "nav_deposits", route: "/deposits" },
  { key: "nav_deposit_addresses", route: "/deposit-addresses" },
  { key: "nav_payment_links", route: "/payment-links" },
  { key: "nav_ledger", route: "/ledger" },
  { key: "nav_payouts", route: "/payouts" },
  { key: "nav_trading", route: "/" },
  { key: "nav_withdrawals", route: "/withdrawals" },
  { key: "nav_workflows", route: "/workflows" },
];

// Concrete routes. `public: true` marks the ones that render without a session and without the
// shell (React had these outside <ProtectedRoutes>). Unmatched paths fall back to "/" — the React
// router's <Route path="*" element={<Navigate to="/" replace />}>.
export const ROUTES = [
  { path: "/", title: "Trading", loader: () => import("./screens/Dashboard.svelte") },
  { path: "/balances", title: "Balances", loader: () => import("./screens/Balances.svelte") },
  { path: "/client", title: "Client Info", loader: () => import("./screens/ClientInfo.svelte") },
  { path: "/deposits", title: "Deposits", loader: () => import("./screens/Deposits.svelte") },
  {
    path: "/deposit-addresses",
    title: "Deposit Addresses",
    loader: () => import("./screens/DepositAddresses.svelte"),
  },
  {
    path: "/withdrawals",
    title: "Withdrawals",
    loader: () => import("./screens/Withdrawals.svelte"),
  },
  { path: "/payouts", title: "Payouts", loader: () => import("./screens/Payouts.svelte") },
  {
    path: "/payment-links",
    title: "Payment Links",
    loader: () => import("./screens/Invoices.svelte"),
  },
  {
    path: "/payment-links/:id",
    title: "Payment Link",
    loader: () => import("./screens/InvoiceDetails.svelte"),
  },
  {
    path: "/payment-link-review/:id",
    title: "Payment Link Review",
    loader: () => import("./screens/InvoiceDraftDetails.svelte"),
  },
  { path: "/ledger", title: "Ledger", loader: () => import("./screens/Ledger.svelte") },
  { path: "/workflows", title: "Workflows", loader: () => import("./screens/Workflows.svelte") },
  { path: "/logout", title: "Logout", loader: () => import("./screens/Logout.svelte") },

  {
    path: "/login",
    title: "Login",
    public: true,
    loader: () => import("./screens/Login.svelte"),
  },
  {
    path: "/register",
    title: "Register",
    public: true,
    loader: () => import("./screens/Registration.svelte"),
  },
];

export const PUBLIC_PATHS = ROUTES.filter((route) => route.public).map((route) => route.path);
